import { IApiPriceFilteringProfile, IApiPriceFilteringProfilesDefault } from '@cbridge-packages/api';
import { IPriceFiltering, IPriceFilteringDefault } from './priceFiltering.interface';

export namespace PriceFilteringTranslator {
  export function fromApi(priceFiltering: IApiPriceFilteringProfile): IPriceFiltering {
    return {
      priceFilteringId: priceFiltering.id,
      name: priceFiltering.name,
      maxClientMarketDepth: priceFiltering.maxClientMarketDepth,
      maxBookbMarketDepth: priceFiltering.maxBookbMarketDepth,
    };
  }

  export function toApi(priceFiltering: IPriceFiltering): IApiPriceFilteringProfile {
    return {
      id: priceFiltering.priceFilteringId,
      name: priceFiltering.name,
      maxClientMarketDepth: priceFiltering.maxClientMarketDepth,
      maxBookbMarketDepth: priceFiltering.maxBookbMarketDepth,
    };
  }

  export function defaultFromApi(priceFiltering: IApiPriceFilteringProfilesDefault): IPriceFilteringDefault {
    return {
      priceFilteringDefaultId: priceFiltering.priceFilteringDefaultId,
      maxClientMarketDepth: priceFiltering.maxClientMarketDepth,
      maxBookbMarketDepth: priceFiltering.maxBookbMarketDepth,
    };
  }
}
